const GuideNames = {
  BULK_USER_UPLOAD_GUIDE: "bulkUserUploadGuide"
};

export default GuideNames;
